import React from 'react';
import { AtlassianLogo, ConfluenceLogo } from '@atlaskit/logo';

import { CobrandingComponents } from '../shared-cobranding';

import { BlankBackground, IdentityWrapper } from './common/styled';

function BlankBackgroundWithLogo({ children }: { children: React.ReactNode }) {
  return (
    <BlankBackground>
      <ConfluenceLogo appearance="brand" size="large" />
      <IdentityWrapper>{children}</IdentityWrapper>
      <AtlassianLogo appearance="brand" size="small" />
    </BlankBackground>
  );
}

const WacSignupOTPExperimentConfluence: CobrandingComponents = {
  background: BlankBackgroundWithLogo,
  logo: null,
  whiteboxWidth: '460px',
  hideWhiteboxBorder: true,
};

export default WacSignupOTPExperimentConfluence;
